import DynamicPage from './DynamicPage';
import PassThrough from './PassThrough';

const Index = {
  Dashboard: DynamicPage,
  PassThrough : PassThrough
};

export default Index;